import { PaletteColor } from '@mui/material/styles/createPalette';

import { theme } from '~/theme';

export const useSxStyles = () => {
  const itemBufferSize = 2;
  const avatarBufferSize = 1.5;

  const stepLine = {
    color: theme.palette.divider,
    width: '2px',
    beginLength: theme.spacing(avatarBufferSize),
  };

  const getStatusColor = (paletteColor: PaletteColor) => {
    return {
      backgroundColor: paletteColor.main,
      color: paletteColor.contrastText,
    };
  };

  return {
    processItem: {
      display: 'grid',
      gridTemplateColumns: 'auto 1fr',
      gridTemplateRows: `auto 1fr ${theme.spacing(itemBufferSize)}`,
      gridTemplateAreas: `
        "badge time"
        "badge info"
        "badge buffer"
      `,
      padding: theme.spacing(0, 1),
      '& > .badge': {
        gridArea: 'badge',
        backgroundImage: `linear-gradient(${stepLine.color}, ${stepLine.color})`,
        backgroundSize: `${stepLine.width} 100%`,
        backgroundPosition: 'top center',
        backgroundRepeat: 'no-repeat',
        padding: theme.spacing(
          theme.spacing(avatarBufferSize),
          1,
          theme.spacing(avatarBufferSize + itemBufferSize),
          1,
        ),
      },
      '&.first > .badge': {
        backgroundSize: `${stepLine.width} calc(100% - ${stepLine.beginLength})`,
        backgroundPosition: 'bottom center',
      },
      '&.last > .badge': {
        backgroundSize: `${stepLine.width} ${stepLine.beginLength}`,
      },
      '&.first.last > .badge': {
        backgroundImage: 'none',
      },
      '& > .time': {
        gridArea: 'time',
      },
      '& > .info': {
        gridArea: 'info',
        paddingBottom: theme.spacing(1),
        borderRadius: theme.spacing(1),
        backgroundColor: '#fff',
      },
      '& > .buffer': {
        gridArea: 'buffer',
      },
    },
    processStatus: {
      display: 'grid',
      gridTemplateColumns: 'auto 1fr',
      gridTemplateRows: `auto`,
      gridTemplateAreas: `
        "status timestamp"
      `,
      fontSize: '0.8em',
      '& > .status': {
        gridArea: 'status',
        borderRadius: theme.spacing(1, 0, 1, 0),
        padding: theme.spacing(0.5, 1),
        '&.success': getStatusColor(theme.palette.success),
        '&.warning': getStatusColor(theme.palette.warning),
        '&.error': getStatusColor(theme.palette.error),
        '&.info': getStatusColor(theme.palette.info),
        '&.disabled': {
          backgroundColor: theme.palette.action.disabledBackground,
          color: theme.palette.action.disabled,
        },
      },
      '& > .timestamp': {
        gridArea: 'timestamp',
        padding: theme.spacing(0.5, 1),
      },
    },
  };
};
